import hasFollowupAccess from '@/auth/booking-followup-access'
import ability from './ability'

export const canView = (action, resource) => {
  if (resource === 'bookingFollowup') return hasFollowupAccess()
  return ability.can(action || 'read', resource)
}
export const canNavigate = to => to.matched.some(route => canView(route.meta.action || 'read', route.meta.resource))

// export const canNavigate = ()=>(true)

export const _ = undefined
